import { helper as buildHelper } from '@ember/component/helper';

export default buildHelper(() => Boolean(window && window.ReactNativeWebView));
